import React from 'react';
import { cn } from '@/utils/cn';

export interface EmptyStateProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  icon?: React.ReactNode;
  /** Usually a <Button>. */
  action?: React.ReactNode;
  /** `inline` = dashed box inside a card section; `block` = centered, for a whole panel or page. */
  variant?: 'inline' | 'block';
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ title, description, icon, action, variant = 'block', className }) => (
  <div
    className={cn(
      'flex flex-col items-center justify-center gap-2 text-center',
      variant === 'inline'
        ? 'rounded-control border border-dashed border-ui-border2 bg-ui-subtle px-4 py-4'
        : 'px-4 py-12',
      className,
    )}
  >
    {icon && <div className="text-icon" aria-hidden="true">{icon}</div>}
    <p className={cn('font-medium text-ui-text2', variant === 'inline' ? 'text-xs' : 'text-sm')}>{title}</p>
    {description && <p className="text-xs text-ui-text3">{description}</p>}
    {action && <div className="mt-1">{action}</div>}
  </div>
);

export default EmptyState;
